import { useEffect, useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ProductCard } from "../components/ProductCard";
import { ChatbotWidget } from "../components/ChatbotWidget";
import { useToggle } from "../contexts/ToggleContext";
import { api } from "../lib/api";

export default function SearchPage() {
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const enabled = useToggle("search");
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (!q) {
            setItems([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get("/products", { params: { q, limit: 48 } })
            .then(({ data }) => {
                setItems(data.items || []);
                setTotal(data.total || 0);
            })
            .finally(() => setLoading(false));
    }, [q]);

    if (!enabled) return <Navigate to="/" replace />;

    return (
        <div className="min-h-screen bg-ivory" data-testid="search-page">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
                <span className="label-eyebrow">Search</span>
                <h1 className="mt-3 font-display text-4xl sm:text-5xl text-inkDark tracking-tight">
                    {q ? `Results for "${q}"` : "Search"}
                </h1>
                <p className="mt-2 text-inkMuted">{loading ? "Searching…" : `${total} pieces`}</p>

                <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-8" data-testid="search-results-grid">
                    {items.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
                {!loading && items.length === 0 && q ? (
                    <div className="bg-beige rounded-2xl p-12 text-center text-inkMuted mt-8" data-testid="search-empty">
                        Nothing matches &ldquo;{q}&rdquo; yet. Try sarees, lehengas or a fabric like silk.
                    </div>
                ) : null}
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
